import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
const config = {
  apiKey: "AIzaSyCmeKtaXmHszetPe1FzcVELPnJkCdKM-vo",
  authDomain: "telemontv-web.firebaseapp.com",
  databaseURL: "https://telemontv-web.firebaseio.com",
  projectId: "telemontv-web",
  storageBucket: "telemontv-web.appspot.com",
  messagingSenderId: "330477492314",
};

firebase.initializeApp(config);

const db = firebase.firestore();
const storage = firebase.storage();
const packages = db.collection("packages");
const sections = db.collection("sections");
const requests = db.collection("requests");
const news = db.collection("news");
const programs = db.collection("programs");
const userLogin = db.collection("userLogin");
const userAdminLogin = db.collection("userAdminLogin");
const newCategories=db.collection("newCategories");
const auth = firebase.auth();

export {
  firebase,
  db,
  auth,
  packages,
  sections,
  requests,
  news,
  userAdminLogin,
  storage,
  userLogin,
  programs,
  newCategories
};
